import { Report } from "interfaces";
import { ModalResolveReportPartiallyWrongBodyLeftToneOfVoice } from "./ModalResolveReportPartiallyWrongBodyLeftToneOfVoice";

export const ModalResolveReportPartiallyWrongBodyLeft = ({
  report,
}: {
  report: Report;
}) => {
  return (
    <div className="modal-resolve-source-container">
      <ModalResolveReportPartiallyWrongBodyLeftToneOfVoice
        answer={report.answer!}
      />
    </div>
  );
};
